<h1 mat-dialog-title i18n>Import Customer File</h1>
<div mat-dialog-content>
  <form #importForm="ngForm" (ngSubmit)="importCustomer(importForm)" class="container">
    <div class="form-group row">
      <div class="col-sm-12 form-inline">
        <div class="control-wrapper">
          <label for="workOrderSqrFt" i18n>File:</label>
          <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"
                           accept=".csv, .xlsx, text/csv, img/gif, application/openxmlformats-officedocument.spreadsheetml.sheet"></app-file-upload>
        </div>
      </div>
    </div>
    <div *ngIf="errors" class="mt-3 alert alert-danger">
      {{ errors }}
    </div>
    <div [hidden]="!importForm.submitted || importForm.valid"
         class="mt-3 alert alert-danger" i18n>Validation issues encountered.  Please review your entered information.</div>
    <div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </form>
</div>
